export const PROGRESS_COLORS = {
    primary: 'primary',
    secondary: 'secondary',
    tertiary: 'tertiary',
    destructive: 'destructive',
    success: 'success',
    warning: 'warning',
    info: 'info',
    purple: 'purple',
    pink: 'pink',
    orange: 'orange',
    teal: 'teal',
    cyan: 'cyan',
    indigo: 'indigo',
} as const

export const PROGRESS_COLORS_ARRAY = Object.values(PROGRESS_COLORS)
